import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { message, Select } from 'antd'
import styles from './index.module.scss'
import scrollLock from '../../../../../utils/scroll-lock'
import request from '../../../../../network/request'

interface IProps {
  opType: string
  order: any
  onClose: () => void
  onRefreshData: () => any
}

export default function OptModal({
  opType,
  order,
  onClose,
  onRefreshData,
}: IProps) {
  const history = useHistory()
  const { path } = useRouteMatch()
  const remarkInputRef = useRef<HTMLTextAreaElement>(null)
  const [reasonList, setReasonList] = useState<any>([])
  const [vehicleList, setVehicleList] = useState<any[]>([])
  const [isOpting, setIsOpting] = useState(false)

  const reasonSelectRef = useRef<any>()
  const vehicleInputRef = useRef<any>()

  useEffect(() => {
    scrollLock.enable()
    return () => {
      scrollLock.disable()
    }
  }, [])

  useEffect(() => {
    if (opType === 'terminate') {
      getInitialReason()
    } else if (opType === 'start') {
      getInitialVehicle()
    }
  }, [opType])

  const getInitialReason = async () => {
    try {
      const res = await request.get(
        '/dragon/service/order/finish/reason/list',
        {}
      )
      if (Array.isArray(res)) {
        setReasonList(Array.from(new Set(res)))
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getInitialVehicle = async () => {
    try {
      const res = await request.get('/dragon/service/order/vehicle/list', {})
      if (Array.isArray(res)) {
        setVehicleList(res)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const Header = () => {
    let titleTxt = ''
    switch (opType) {
      case 'receive':
        titleTxt = '确认接单？'
        break
      case 'chargeback':
        titleTxt = '确认退单？'
        break
      case 'arrival':
        titleTxt = '确认已到达？'
        break
      case 'addRemark':
        titleTxt = '新增备注'
        break
      case 'terminate':
        titleTxt = '请填写提前结束原因'
        break
      case 'start':
        titleTxt = '确认服务车牌号'
        break
      case 'cancel':
        titleTxt = '确认取消订单？'
        break
    }

    if (opType === 'finish' || titleTxt === '') {
      return null
    }

    return (
      <div className={styles.headerWrap}>
        <h3 className={styles.title}>{titleTxt}</h3>
      </div>
    )
  }

  const Content = () => {
    return (
      <>
        {opType === 'receive' ||
        opType === 'chargeback' ||
        opType === 'arrival' ? null : (
          <div className={styles.contentWrap}>
            {(opType === 'addRemark' ||
              opType === 'terminate' ||
              opType === 'cancel') && (
              <RemarkInput placeholder="请输入备注"></RemarkInput>
            )}
            {opType === 'terminate' && reasonList.length > 0 && (
              <ReasonSelect ref={reasonSelectRef}></ReasonSelect>
            )}
            {opType === 'start' && (
              <PlateSelect ref={vehicleInputRef}></PlateSelect>
            )}
            {opType === 'finish' && <Success></Success>}
          </div>
        )}
      </>
    )
  }

  const Success = () => {
    return (
      <div className={styles.successWrap}>
        <div className={styles.icon}></div>
        <p className={styles.subTitle}>恭喜！服务单已完成</p>
      </div>
    )
  }

  const RemarkInput = ({ placeholder }) => {
    return (
      <div className={styles.addRemark}>
        <textarea
          ref={remarkInputRef}
          placeholder={placeholder}
          rows={5}
          maxLength={500}
          className={styles.textarea}
        />
      </div>
    )
  }

  const ReasonSelect = forwardRef((props, ref) => {
    const [selectedReason, setSelectedReson] = useState<any>([])

    useImperativeHandle(ref, () => ({
      selectedReason,
    }))

    const handleSelectReason = (reason) => {
      const index = selectedReason.indexOf(reason)
      if (index < 0) {
        const tmp = [...selectedReason, reason]
        setSelectedReson(tmp)
      } else {
        const tmp = [...selectedReason]
        tmp.splice(index, 1)
        setSelectedReson(tmp)
      }
    }

    return (
      <div className={styles.reasonList}>
        {reasonList.map((reason, reasonIndex) => {
          return (
            <div
              className={[
                styles.reasonItem,
                selectedReason.includes(reason) ? styles.selected : '',
              ].join(' ')}
              key={reasonIndex}
              onClick={() => handleSelectReason(reason)}
            >
              {reason}
            </div>
          )
        })}
      </div>
    )
  })

  const PlateSelect = forwardRef((props, ref) => {
    const [selectedVehicle, setSelectedVehicle] = useState<any>({
      plateNo: order.serviceVehiclePlateNo,
      vin: order.serviceVehicleVin,
    })
    const [selectedPlate, setSelectedPlate] = useState<string>(
      order.serviceVehiclePlateNo || ''
    )

    useImperativeHandle(ref, () => ({
      selectedVehicle,
    }))

    const { Option } = Select

    const options = vehicleList.map((d) => (
      <Option key={d.value} value={d.plateNo}>
        {d.plateNo}
      </Option>
    ))

    const handleChange = (value) => {
      setSelectedPlate(value)

      const curVehicle = vehicleList.find((item) => {
        return item.plateNo === value
      })

      if (curVehicle) {
        setSelectedVehicle({
          plateNo: curVehicle.plateNo,
          vin: curVehicle.vin,
        })
      }
    }

    return (
      <div className={styles.plateInputWrap}>
        <Select
          style={{ width: '100%' }}
          showSearch
          value={selectedPlate}
          onChange={handleChange}
          notFoundContent="无匹配车辆"
        >
          {options}
        </Select>
      </div>
    )
  })

  const Footer = () => {
    const showCancel = opType !== 'finish'
    let confirmTxt = '确认'

    switch (opType) {
      case 'receive':
      case 'chargeback':
      case 'calcel':
      case 'addRemark':
        confirmTxt = '确认'
        break
      case 'terminate':
        confirmTxt = '提交'
        break
      case 'start':
        confirmTxt = '确认出发'
        break
      case 'finish':
        confirmTxt = '知道了'
        break
    }

    return (
      <div className={styles.footerWrap}>
        {showCancel && (
          <div className={styles.cancel} onClick={handleCancel}>
            取消
          </div>
        )}
        <div className={styles.confirm} onClick={handleConfirm}>
          {confirmTxt}
        </div>
      </div>
    )
  }

  const handleCancel = () => {
    onClose()
  }

  const handleConfirm = async () => {
    if (isOpting) {
      return
    }

    let remarkInfo: any = ''
    if (opType === 'addRemark') {
      remarkInfo = remarkInputRef.current?.value

      if (remarkInfo?.trim().length === 0) {
        message.warn('请输入备注信息')
        return
      }

      await handleAddRemark(remarkInfo)
    } else if (opType === 'terminate') {
      remarkInfo = remarkInputRef.current?.value
      let reasonSelect = reasonSelectRef?.current?.selectedReason

      if (remarkInfo?.trim().length === 0 && reasonSelect.length === 0) {
        let msg =
          reasonList.length === 0 ? '请输入结束原因' : '请输入或选择结束原因'
        message.warn(msg)
        return
      }

      if (reasonSelect.length > 0) {
        let selectRemark = reasonSelect.join(';')

        remarkInfo =
          remarkInfo.length > 0 ? `${remarkInfo};${selectRemark}` : selectRemark
      }

      await handleOperate(remarkInfo)
    } else if (opType === 'start') {
      let selectedVehicle = vehicleInputRef?.current?.selectedVehicle

      if (!selectedVehicle) {
        return
      }
      await handleStart(selectedVehicle)
    } else if (opType === 'finish') {
      onClose()
      // 通知上层页面刷新数据
      onRefreshData()
    } else if (opType === 'cancel') {
      remarkInfo = remarkInputRef.current?.value

      if (remarkInfo?.trim().length === 0) {
        message.warn('请输入备注信息')
        return
      }

      await handleOperate(remarkInfo)
    } else {
      await handleOperate(remarkInfo)
    }
  }

  const handleOperate = async (remark = '') => {
    setIsOpting(true)
    try {
      await request.post('/dragon/service/order/operate', {
        operateType: opType,
        serviceOrderId: order.id,
        remark: remark,
      })

      onClose()
      if (opType !== 'chargeback' && opType !== 'cancel') {
        // 通知上层页面刷新数据
        onRefreshData()
      } else {
        // 退单、取消订单时在详情页面则后退，在列表页则刷新
        if (path === '/ms/list') {
          onRefreshData()
        } else {
          history.goBack()
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsOpting(false)
    }
  }

  const handleStart = async (vehicle) => {
    setIsOpting(true)
    try {
      await request.post('/dragon/service/order/operate', {
        operateType: opType,
        serviceOrderId: order.id,
        serviceVehiclePlateNo: vehicle.plateNo,
        serviceVehicleVin: vehicle.vin,
      })

      onClose()
      // 通知上层页面刷新数据
      onRefreshData()
    } catch (err) {
      console.log(err)
    } finally {
      setIsOpting(false)
    }
  }

  const handleAddRemark = async (remark = '') => {
    setIsOpting(true)
    try {
      await request.post('/dragon/service/order/remark/save', {
        serviceOrderId: order.id,
        remark: remark,
      })

      onClose()
      // 通知上层页面刷新数据
      onRefreshData()
    } catch (err) {
      console.log(err)
    } finally {
      setIsOpting(false)
    }
  }

  return (
    <div
      className={styles.modalWrap}
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <div className={styles.modelContainer}>
        <Header></Header>
        <Content></Content>
        <Footer></Footer>
      </div>
    </div>
  )
}
